import axiosInstance from "./axiosInstance";

// Get all pdfs
// export const getPdfs = async (category) => {
//   // const res = await axiosInstance.get("/pdfs");
//   const res = await axiosInstance.get(`/pdfs${category ? `?category=${category}` : ""}`);
//   return res.data.pdfs;
// };
export const getPdfs = async (category) => {
  try {
    // const res = await axiosInstance.get(`/pdfs${category ? `?category=${category}` : ""}`);
    // const res = await axiosInstance.get(`/pdfs?category=${category}`);
    if (!category) throw new Error("Category is required for fetching PDFs.");
    const res = await axiosInstance.get(`/pdfs?category=${encodeURIComponent(category)}`);
    
    console.log("Fetched PDFs:", res.data.pdfs); // Debugging

    const formattedPdfs = res.data.pdfs.map(pdf => ({
      ...pdf,
      pdfUrl: pdf.pdfUrl || pdf.fileUrl,
      date: pdf.date
    }));
    // return res.data.pdfs

    return formattedPdfs;
  } catch (error) {
    console.error("Error fetching PDFs:", error);
    return [];
  }
};


// Get a single pdf by ID
export const getPdfById = async (id) => {
  const res = await axiosInstance.get(`/pdfs/${id}`);
  return res.data.pdf;
};

// Upload a pdf
// export const uploadPdf = async (formData) => {
//   const res = await axiosInstance.post("/pdfs/upload", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return res.data.pdf;
// };
export const uploadPdf = async (formData, category, date) => {
  if (!category) throw new Error("Category is required for uploading PDFs.");
  if (!date) throw new Error("Date is required for uploading PDFs.");

  if (!formData.has("category")) {
    formData.append("category", category); // ✅ Ensure category is properly added
  }
  if (!formData.has("date")) {
    formData.append("date", date);
  }

  console.log("📤 Final FormData being sent for PDF:", [...formData.entries()]); // Debugging output

  const res = await axiosInstance.post("/pdfs/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data.pdf;
};



// Create an external PDF (e.g., hosted URL)
// export const createExternalPdf = async (pdfData) => {
//   const res = await axiosInstance.post("/pdfs/external", pdfData);
//   return res.data.pdf;
// };
export const createExternalPdf = async (pdfData) => {
  if (!pdfData.category) throw new Error("Category is required for adding external PDFs.");
  if (!pdfData.date) throw new Error("Date is required for adding external PDFs.");

  try {
    console.log("📤 Sending external PDF data:", pdfData);

    const res = await axiosInstance.post("/pdfs/external", pdfData); // ✅ Ensure category is sent
    console.log("✅ API Response for createExternalPdf:", res.data);

    return res.data.pdf;
  } catch (error) {
    console.error("❌ Error creating external PDF:", error.response?.data || error.message);
    throw error;
  }
};



// Update a pdf by ID
// export const updatePdf = async (id, formData) => {
//   const res = await axiosInstance.put(`/pdfs/upload/${id}`, formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return res.data.pdf;
// };
export const updatePdf = async (id, updateData) => {
  if (!updateData.category) throw new Error("Category is required for updating PDFs.");

  const res = await axiosInstance.put(`/pdfs/${id}`, updateData);
  return res.data.pdf;
};

// Delete a pdf by ID
// export const deletePdf = async (id) => {
//   const res = await axiosInstance.delete(`/pdfs/${id}`);
//   return res.data;
// };
export const deletePdf = async (id, category) => {
  // if (!category) throw new Error("Category is required for deleting PDFs.");

  const res = await axiosInstance.delete(`/pdfs/${id}`);
  return res.data;
};

